// Ionic & Angular Imports
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';

// Interfaces
export interface InspectionType {
    id: number;
    name: string;
    description: string;
}

@Injectable()
export class rsInspectionTypeSvc {

    constructor( private http: Http ) 
    {
        
    }

    getInspectionTypes( filter: string = "visible" ) : Observable<InspectionType[]> {
        // Return our observable
        return Observable.create( observer => {
            // This method gets run when an object subscribes
            this.http.get( 'http://dfr.hydrocon.com/api/v1/inspectiontype/filters/' + filter, {
                withCredentials: true
            })
            .map( res => {
                return res.json().response.inspectiontype;
            })
            .subscribe( result => {
                // operation successful
                observer.next(result);
            }, err=> {
                // error encountered
                observer.error(err);
            }, () => {
                // operation complete
                observer.complete();
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/inspectiontype.service.ts